export default __webpack_public_path__ + "static/media/architecture.80d0b48e.png";